import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../../store/actions/authActions.ts'
import { RootState, useAppDispatch } from '../../store/index.ts'
import { useReloadPreview } from '../../hooks/reloadPreview.tsx'

const website_url = import.meta.env.VITE_WEBSITE_URL
export const PreviewBlock = () => {
  
  const dispatch = useAppDispatch()
  const {
    user: { data: user },
    loading,
  } = useSelector((state: RootState) => state.userReducer)

  const [reloadPreview] = useReloadPreview()
  const [frameID, setFrameID] = useState(0)

  useEffect(() => {
    if (!user?.id && !loading) {
      dispatch(getCurrentUser())
    }
    
    if (reloadPreview) {
      setFrameID(frameID + 1)
    }
  })

  return (
    <div className="relative mx-auto hidden h-[calc(100vh_-_189px)] w-[340px] rounded-[2.5rem] border-[12px] border-gray-800 bg-gray-800 sm:flex 2xl:h-[1040px] 2xl:w-[680px]">
      <div className="absolute -start-[17px] top-[72px] h-[32px] w-[6px] rounded-s-lg bg-gray-800" />
      <div className="absolute -start-[17px] top-[124px] h-[46px] w-[6px] rounded-s-lg bg-gray-800" />
      <div className="absolute -start-[17px] top-[178px] h-[46px] w-[6px] rounded-s-lg bg-gray-800" />
      <div className="absolute -end-[17px] top-[142px] h-[64px] w-[6px] rounded-e-lg bg-gray-800" />
      <div className="h-[calc(100vh_-_215px)] w-[320px] overflow-hidden rounded-[2rem] bg-white 2xl:h-[1014px] 2xl:w-[655px]">
        <iframe
          key={frameID}
          id="preview"
          src={`${website_url}/${user?.username}`}
          width={'100%'}
          height={'100%'}
        ></iframe>
      </div>
    </div>
  )
}
